import script from "./SummaryChoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryChoices.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryChoices.vue?vue&type=style&index=0&id=5cb44bf0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb44bf0"]])

export default __exports__